import male from "./male.jsx";
import female from "./female.jsx";

export default {
  male,
  female,
};
